import React from 'react';

const CancellationRefundPolicy = () => {
  return (
    <div>
        <div className="container">
          <h1>Cancellation &amp; Refund Policy</h1>
          <p><strong>Effective Date:</strong> 12/06/2025</p>

          <p>
            At <strong>Empower Conference</strong>, we strive to provide all attendees with a seamless and valuable experience. 
            We understand that unforeseen circumstances can arise. This policy outlines the terms for cancellations and refunds.
          </p>

          <h2>1. General Policy</h2>
          <p>
            All registrations for Empower Conference are considered final. However, cancellations may be considered on a case-by-case basis under the following conditions:
          </p>

          <h2>2. Valid Reasons for Cancellation</h2>
          <p>Cancellations will be permitted only in the event of the following genuine emergencies:</p>
          <ul>
            <li>Medical emergencies (with supporting medical documents)</li>
            <li>Serious personal emergencies such as bereavement or accidents</li>
            <li>Other unavoidable and verifiable emergencies (subject to review)</li>
          </ul>

          <h2>3. Request Procedure</h2>
          <ul>
            <li>
              Cancellation requests must be emailed to <a href="mailto:info@empowerconference.in">info@empowerconference.in</a> with subject line: <em>“Cancellation Request – [Your Name]”</em>.
            </li>
            <li>You must attach valid documentation (e.g., medical certificate, travel restrictions, etc.)</li>
            <li>All requests must be submitted no later than 5 days before the event start date, except in extreme emergencies.</li>
          </ul>

          <h2>4. Refund Terms</h2>
          <ul>
            <li>If approved, the refund amount will be processed within 14 working days.</li>
            <li>A processing fee (if applicable) or transaction charges may be deducted.</li>
            <li>No refunds will be issued for cancellations made without valid proof or after the event.</li>
          </ul>

          <h2>5. Non-Refundable Conditions</h2>
          <ul>
            <li>No-show at the event without notice or supporting documents</li>
            <li>Voluntary withdrawal or dissatisfaction with event content</li>
            <li>Inability to attend due to minor schedule conflicts</li>
          </ul>

          <h2>6. Contact</h2>
          <p>If you need help regarding cancellations, please contact us at:</p>
          <p>
            📧 Email: <a href="mailto:info@empowerconference.in">info@empowerconference.in</a><br />
            📍 Address: Assistech Lab, Indian Institute of Technology Delhi, New Delhi, India 
          </p>

          <p>We thank you for your understanding and cooperation.</p>
        </div>
    </div>
  );
};

export default CancellationRefundPolicy;
